import { authApiCall } from '../auth/saga';

// ---------------------------------------------------------------------------
// COUPON stats
// ---------------------------------------------------------------------------

// Daily stats per coupon. params: { coupon_id?, business_id?, days? }
export const getDailyStats = params =>
  authApiCall({
    url: '/stats/daily-stats/',
    method: 'get',
    params,
  });

// Position-bucket breakdown. params: { coupon_id?, days? }
export const getPositionBuckets = params =>
  authApiCall({
    url: '/stats/position-buckets/',
    method: 'get',
    params,
  });

// Screen breakdown — which app screen impressions/clicks fired from.
// params: { coupon_id?, screen?, days? }
export const getScreenStats = params =>
  authApiCall({
    url: '/stats/screen-stats/',
    method: 'get',
    params,
  });

// Windowed ranking features. params: { days? }
export const getRanking = params =>
  authApiCall({
    url: '/stats/ranking/',
    method: 'get',
    params,
  });

// ---------------------------------------------------------------------------
// BUSINESS stats
// ---------------------------------------------------------------------------

// Aggregated per-business daily series: impressions, clicks, unique
// impressions/clicks, favorites, followers (total + new per day).
// params: { business_id?, days? } — omit business_id for the admin
// "all businesses" view.
export const getBusinessStats = params =>
  authApiCall({
    url: '/stats/business-stats/',
    method: 'get',
    params,
  });

// ---------------------------------------------------------------------------
// USER stats
// ---------------------------------------------------------------------------

// Per-user per-coupon daily stats (permanent). Joins coupon name.
// params: { user_id?, coupon_id?, days? }
export const getUserCouponStats = params =>
  authApiCall({
    url: '/stats/user-coupon-stats/',
    method: 'get',
    params,
  });

// Per-user daily stats from user_daily_stats table.
// params: { user_id?, days? }
// Without user_id the backend scopes to request.user (self). Since
// user_daily_stats now also carries guest_pseudo_user_id() rows, the
// backend defaults this to signed-in only (user_id > 0) unless a
// user_type param says otherwise — see getGuestDailyStats below for
// the guest-scoped counterpart.
export const getUserDailyStats = params =>
  authApiCall({
    url: '/stats/user-daily-stats/',
    method: 'get',
    params,
  });

// Guest-scoped daily stats — same endpoint/table as getUserDailyStats,
// but forces user_type=guest server-side so it only sees rows keyed by a
// negative guest_pseudo_user_id() (one row per anonymous session per day,
// not a persistent user). params: { days? }
export const getGuestDailyStats = params =>
  authApiCall({
    url: '/stats/user-daily-stats/',
    method: 'get',
    params: { ...params, user_type: 'guest' },
  });

// Raw granular events for the current user (last 14 days while partition lives).
// params: { days?, event_type?, coupon_id?, screen? }
export const getUserRawEvents = params =>
  authApiCall({
    url: '/stats/user-events/',
    method: 'get',
    params,
  });

// ---------------------------------------------------------------------------
// EVENT ingest (batch write — fire and forget)
// ---------------------------------------------------------------------------

// events is an array of plain event objects; backend reads user_id from auth.
export const sendEvents = events =>
  authApiCall({
    url: '/stats/events/',
    method: 'post',
    data: { events },
  });